import script from "./form-file-upload.vue?vue&type=script&lang=ts&setup=true"
export * from "./form-file-upload.vue?vue&type=script&lang=ts&setup=true"

import "./form-file-upload.css?vue&type=style&index=0&id=b2a3505c&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2a3505c"]])

export default __exports__